"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.twilioMessageResponseSchema = void 0;
const zod_1 = require("zod");
/** Twilio returns `sid` on success and `message`/`code` on failure, never both. */
exports.twilioMessageResponseSchema = zod_1.z.object({
    sid: zod_1.z.string().optional(),
    message: zod_1.z.string().optional(),
    code: zod_1.z.number().optional(),
});
//# sourceMappingURL=twilio.js.map